export const Container = ({ children }: { children: React.ReactNode }) => (
  <div className="mx-auto max-w-6xl px-6 sm:px-8 lg:px-12">{children}</div>
);
